import { render, staticRenderFns } from "./ToggleAutomationButton.vue?vue&type=template&id=53b353af"
import script from "./ToggleAutomationButton.vue?vue&type=script&lang=js"
export * from "./ToggleAutomationButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports